export default function appHelper() {

  const transformFormDataToList = (formData) => {
    return Object.entries(formData).map(([key, value]) => ({
      key,
      ...value,
    }));
  };


  const capitalize = (text) => {
    if (!text) return '';
    return text
      .split(' ') // Split the string into an array of words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words back into a single string
  };

  const formatDateToDayMonthYear = (dateString) => {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' }); // Get full month name
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;


  }

  const changeToTimeString = (val) => {
    if(val){
      
      const timeString = val;
      const [hours, minutes] = timeString.split(":").map(Number);

      if(hours===0 && minutes===0){
        return 0;
      }
  
      let readableFormat = "";
      if (hours > 0) {
        //readableFormat += `${hours} hr${hours > 1 ? 's' : ''}`;
        readableFormat += `${hours} hr`;
      }

      if (minutes > 0) {
       // if (readableFormat) readableFormat += " and ";
        if (readableFormat) readableFormat += " ";
      //  readableFormat += `${minutes} min${minutes > 1 ? 's' : ''}`;
        readableFormat += `${minutes} min`;
      }
  
      return readableFormat;
    }
    return "";

  }


  const truncateByLength = (text,maxLength=12)=>{
     if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  }


  return { transformFormDataToList, capitalize, formatDateToDayMonthYear,changeToTimeString,truncateByLength  }
}




